import React, {Component} from 'react';
import '../css/style.css';
import WorkOrderPrint from './WorkOrderPrint';

class OrderPrintContent extends Component {

    componentDidMount () {
    }

    renderWorkOrderPrint(workOrder) {
        return (
          <div key={workOrder.id} className="orderPrint">
            <WorkOrderPrint workOrder={workOrder}/>
          </div>
        );
    }
      
    render() {
        return(
        <div className="orderPrint">
            {this.props.workOrders.map(workOrder => {
              return this.renderWorkOrderPrint(workOrder)
            })}
        </div>
        );
    }
}

export default OrderPrintContent;